<aside class="flex h-screen flex-col bg-[#2f465a] px-4 py-5 text-white">
  <div class="mb-6 text-center">
    <img src="logo-blanco.png" alt="Logo" class="mx-auto h-10 w-auto" />
  </div>

  <div class="flex-1 space-y-5 overflow-y-auto">
    <div>
      <h6
        class="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-300"
      >
        General
      </h6>
      <ul class="space-y-1">
        @for (item of generalItems; track $index) {
          <li>
            <a
              [routerLink]="item.link"
              (click)="cambiarActivo(item.link); cerrarSidebar()"
              class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition"
              [class.bg-sky-500]="item.activo"
              [class.text-white]="item.activo"
              [class.text-slate-200]="!item.activo"
              [class.hover:bg-white/10]="!item.activo"
            >
              <i class="bi" [ngClass]="item.icono"></i>
              <span>{{ item.titulo }}</span>
            </a>
          </li>
        }
      </ul>
    </div>

    <div>
      <h6
        class="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-300"
      >
        Modulos
      </h6>
      <ul class="space-y-1">
        @for (item of moduleItems; track $index) {
          <li>
            <a
              [routerLink]="item.link"
              (click)="cambiarActivo(item.link); cerrarSidebar()"
              class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition"
              [class.bg-sky-500]="item.activo"
              [class.text-white]="item.activo"
              [class.text-slate-200]="!item.activo"
              [class.hover:bg-white/10]="!item.activo"
            >
              <i class="bi" [ngClass]="item.icono"></i>
              <span>{{ item.titulo }}</span>
            </a>
          </li>
        }
      </ul>
    </div>

    <div>
      <h6
        class="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-300"
      >
        Administracion
      </h6>
      <ul class="space-y-1">
        @for (item of adminItems; track $index) {
          <li>
            <a
              [routerLink]="item.link"
              (click)="cambiarActivo(item.link); cerrarSidebar()"
              class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition"
              [class.bg-sky-500]="item.activo"
              [class.text-white]="item.activo"
              [class.text-slate-200]="!item.activo"
              [class.hover:bg-white/10]="!item.activo"
            >
              <i class="bi" [ngClass]="item.icono"></i>
              <span>{{ item.titulo }}</span>
            </a>
          </li>
        }
      </ul>
    </div>
  </div>

  <div class="mt-4 rounded-xl border border-white/10 bg-white/5 p-3">
    @if (currentUser) {
      <div class="mb-3">
        <div class="mb-2 flex items-center gap-3">
          <i class="bi bi-person-circle text-3xl"></i>
          <div>
            <div class="text-sm font-semibold">
              {{ currentUser.nombreCompleto }}
            </div>
            <div class="text-xs text-slate-300">{{ currentUser.email }}</div>
          </div>
        </div>

        <div
          class="session-counter"
          [class.session-counter--warning]="isSessionExpiringSoon"
        >
          <i class="bi bi-clock mr-1"></i>
          <span>Sesion: {{ sessionRemainingLabel }}</span>
        </div>
      </div>
    }

    <button
      class="flex w-full items-center justify-center gap-2 rounded-lg bg-slate-900 px-3 py-2 text-sm font-medium text-white transition hover:bg-slate-700 disabled:cursor-not-allowed disabled:opacity-70"
      (click)="logout()"
      [disabled]="loading"
    >
      @if (loading) {
        <span
          class="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white"
        ></span>
        Cerrando...
      } @else {
        <i class="bi bi-box-arrow-right"></i>
        Cerrar sesion
      }
    </button>
  </div>
</aside>
